import React, { useEffect, useState } from 'react';
import { Document, pdfjs, Page } from 'react-pdf';

import { connect } from 'react-redux';
import axios from 'axios';
import { OutTable, ExcelRenderer } from 'react-excel-renderer';
import Paper from '../../../assets/images/Paper.svg';
import Stamp from '../../../assets/images/Stamp.svg';
import TimeClockFile from '../../../assets/images/TimeClockFile.svg';
import Archive from '../../../assets/images/Archive.svg';
// import useWindowDimensions from '../../../helpers/hooks/useWindowDimensions';

import styles from './CounterpartySearchResult.module.scss';
import { IState } from '../../../types/interfaces';
import { ICounterpartySearchResult } from '../../../redux/types/interfaces';
import NotFound from '../Errors/NotFound';
import ServerError from '../Errors/ServerError';
import checkIsNum from '../../../helpers/checkIsNum';

const ReactFileViewer = require('react-file-viewer');

interface IProps {
  searchResult: ICounterpartySearchResult;
  errors: string;
}

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const FileViewer = ({ url, type }: { url: string; type: 'pdf' | 'docx' | 'xlsx' }) => {
  const [pageNum, setPageNum] = useState(0);
  // const { width } = useWindowDimensions();

  const [rows, setRows] = useState([] as any);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [cols, setCols] = useState([] as any);

  // const scale = width >= 1919 ? 2.3 : 1.3;

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setPageNum(numPages);
  };

  const renderFile = (fileObj: File) => {
    ExcelRenderer(fileObj, (err: Error, resp: { cols: []; rows: [] }) => {
      if (err) {
        // eslint-disable-next-line no-console
        console.error('[ renderFile ]', err);
      } else {
        const filteredRows = resp.rows.filter((row: []) => row.length !== 0);
        setRows(filteredRows);
        setCols(resp.cols);
        setDataLoaded(true);
      }
    });
  };

  useEffect(() => {
    if (type === 'xlsx') {
      axios({
        url,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const file = new File([response.data], 'file.xlsx', {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          lastModified: new Date().getTime(),
        });

        const fileName = file.name;

        if (fileName.slice(fileName.lastIndexOf('.') + 1) === 'xlsx') {
          renderFile(file);
        }
      });
    }
  }, [type, url]);

  return (
    <div className={type === 'xlsx' && dataLoaded ? styles.excelWrapper : ''}>
      {type === 'pdf' && (
        <Document
          file={url}
          onLoadSuccess={onDocumentLoadSuccess}
          noData={<NotFound withoutBG text="Мы ничего не нашли" />}
        >
          {Array.from(new Array(pageNum > 5 ? 5 : pageNum), (el, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} scale={1.3} />
          ))}
        </Document>
      )}
      {type === 'docx' && <ReactFileViewer fileType={type} filePath={url} />}
      {type === 'xlsx' && dataLoaded && (
        <OutTable
          data={rows}
          columns={cols}
          tableClassName={styles.excelTable}
          tableHeaderRowClass={styles.excelHeading}
        />
      )}
      {type === 'xlsx' && !dataLoaded && <span>Loading XLSX...</span>}
    </div>
  );
};

const CounterpartySearchResult: React.FC<IProps> = ({ searchResult, errors }: IProps) => {
  const [tab, setTab] = useState(1);
  const [isNull, setIsNull] = useState(true);

  const handleClick = (tabNum: number) => {
    setTab(tabNum);
  };

  const {
    expressReportPdfUrl,
    financeAnalyticsPdfUrl,
    ispolnenieKontraktovUrl,
    excerptPdfUrl,
    // arbitrajiUrl,
    affilirovannostUrl,
  } = searchResult;

  const searchResultArr = [
    expressReportPdfUrl,
    financeAnalyticsPdfUrl,
    ispolnenieKontraktovUrl,
    excerptPdfUrl,
    // arbitrajiUrl,
    affilirovannostUrl,
  ];

  // Некоторые отчеты приходят с пустыми полями
  const checkIsNull = (arr: any) => {
    arr.forEach((e: any) => {
      if (e !== null) {
        setIsNull(false);
      }
    });
  };

  useEffect(() => {
    checkIsNull(searchResultArr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkIsNum, searchResultArr]);

  return (
    <>
      {errors === 'NOT_FOUND' && <NotFound />}
      {errors === 'NOT_FOUND' && <NotFound />}
      {errors !== 'NOT_FOUND' && errors !== '' && <ServerError />}

      {!errors && (
        <>
          {isNull ? (
            <NotFound />
          ) : (
            <>
              <div className={styles.container}>
                <div className={styles.header}>
                  <a href={searchResult.archiveUrl} type="button" download className={styles.download}>
                    <img src={Archive} alt="Cкачать одним архивом" className={styles.img} />
                    Cкачать одним архивом
                  </a>
                  <div className={styles.buttons}>
                    {expressReportPdfUrl && (
                      <button
                        type="button"
                        className={`${styles.button} ${tab === 1 && styles.active}`}
                        onClick={() => handleClick(1)}
                      >
                        <img src={TimeClockFile} alt="Экспресс-отчёт" className={styles.img} />
                        Экспресс-отчёт
                      </button>
                    )}

                    {financeAnalyticsPdfUrl && (
                      <button
                        type="button"
                        className={`${styles.button} ${tab === 2 && styles.active}`}
                        onClick={() => handleClick(2)}
                      >
                        <img src={Paper} alt="Финансовая аналитика" className={styles.img} />
                        Финансовая аналитика
                      </button>
                    )}
                    {ispolnenieKontraktovUrl && (
                      <button
                        type="button"
                        className={`${styles.button} ${tab === 3 && styles.active}`}
                        onClick={() => handleClick(3)}
                      >
                        <img src={Paper} alt="Исполнение контрактов" className={styles.img} />
                        Исполнение контрактов
                      </button>
                    )}

                    {excerptPdfUrl && (
                      <button
                        type="button"
                        className={`${styles.button} ${tab === 4 && styles.active}`}
                        onClick={() => handleClick(4)}
                      >
                        <img src={Stamp} alt="Выписка из ЕГРЮЛ" className={styles.img} />
                        Выписка из ЕГРЮЛ
                      </button>
                    )}

                    {/* {arbitrajiUrl && (
                <button
                  type="button"
                  className={`${styles.button} ${tab === 5 && styles.active}`}
                  onClick={() => handleClick(5)}
                >
                  <img src={Paper} alt="Арбитражи" className={styles.img} />
                  Арбитражи
                </button>
              )} */}
                    {affilirovannostUrl && (
                      <button
                        type="button"
                        className={`${styles.button} ${tab === 6 && styles.active}`}
                        onClick={() => handleClick(6)}
                      >
                        <img src={Paper} alt="Аффилированность" className={styles.img} />
                        Аффилированность
                      </button>
                    )}
                  </div>
                </div>
                <div className={styles.results}>
                  <div style={{ overflow: 'hidden' }}>
                    {tab === 1 && expressReportPdfUrl && <FileViewer url={expressReportPdfUrl} type="pdf" />}
                    {tab === 2 && financeAnalyticsPdfUrl && <FileViewer url={financeAnalyticsPdfUrl} type="pdf" />}
                    {tab === 3 && ispolnenieKontraktovUrl && <FileViewer url={ispolnenieKontraktovUrl} type="pdf" />}
                    {tab === 4 && excerptPdfUrl && <FileViewer url={excerptPdfUrl} type="pdf" />}
                    {/* {tab === 5 && arbitrajiUrl && <FileViewer url={arbitrajiUrl} type="docx" />} */}
                    {tab === 6 && affilirovannostUrl && <FileViewer url={affilirovannostUrl} type="docx" />}
                  </div>
                </div>
              </div>
              <div className={styles.wrapperDownloadLink}>
                Полный отчёт вы можете получить по{' '}
                <a href={searchResult?.archiveUrl} type="button" download className={styles.linkDownloadArhive}>
                  ссылке
                </a>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  searchResult: state.counterpartySearchResult.searchResult,
  errors: state.counterpartySearchResult.errors,
});

export default connect(mapStateToProps)(CounterpartySearchResult);
